export const regExp = {
  url: /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
  password: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
  phone: /^(?:(?:\+?\d{1,3}\s*[.-]?)?[([]?\s*(?:\d\s*){1,5}[.\-)\]]?(?:\s*[.-]?\s*\d){4,8})|(?:\d(?:\s*[.-]?\s*\d){6,10})$/,
  zip: /(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$)/,
};
